import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'webstore-chat-gpt-shimmer',
  templateUrl: './chat-gpt-shimmer.component.html',
  styleUrls: ['./chat-gpt-shimmer.component.scss'],
  imports: [CommonModule]
})
export class ChatGptShimmerComponent {

  @Input() _repeat = 2;

  get repeat() {
    return Array.from(Array(this._repeat).keys());
  }

}

